import { render, staticRenderFns } from "./DefaultLayoutSidebar.vue?vue&type=template&id=010a9e1d&scoped=true&"
import script from "./DefaultLayoutSidebar.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayoutSidebar.vue?vue&type=style&index=0&id=010a9e1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a9e1d",
  null
  
)

export default component.exports